var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 6v5.5c0 1.194.421 2.338 1.172 3.182C3.172 15.526 4.189 16 5.25 16c1.06 0 2.078-.474 2.828-1.318.75-.844 1.172-1.989 1.172-3.182V4c0-.796-.281-1.559-.781-2.121C7.969 1.316 7.29 1 6.583 1c-.707 0-1.385.316-1.885.879-.5.562-.781 1.325-.781 2.121v7.5c0 .398.14.78.39 1.06.25.282.59.44.943.44.354 0 .693-.158.943-.44a1.6 1.6 0 00.39-1.06V5",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 6v5.5c0 1.194.421 2.338 1.172 3.182C3.172 15.526 4.189 16 5.25 16c1.06 0 2.078-.474 2.828-1.318.75-.844 1.172-1.989 1.172-3.182V4c0-.796-.281-1.559-.781-2.121C7.969 1.316 7.29 1 6.583 1c-.707 0-1.385.316-1.885.879-.5.562-.781 1.325-.781 2.121v7.5c0 .398.14.78.39 1.06.25.282.59.44.943.44.354 0 .693-.158.943-.44a1.6 1.6 0 00.39-1.06V5",
    stroke: "currentColor",
    strokeOpacity: 0.2,
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default SvgUpload;